export enum ZoomDir {
  In,
  Out
}
